import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IFormulaireItemClass} from '../../../../../core/services/formulaire/formulaire-item.service';
import {IFormulaire, IFormulaireClass} from '../../../../../core/services/formulaire/formulaire.service';
import {IMenuClass} from "../../../../../core/services/menu/menu.service";
import {IMonoOccurrence, IMonoOccurrenceOptions} from "../../../../../core/services/mono-occurrence.service";
import {IComponentController, IScope} from "angular";
import {IMenuItemActionClass} from "../../../../../core/services/menu/menu-item-action.service";
import { INotificationHandler } from '../../../../../core/services/utils/notification-handler.service';

interface IPageGs0016 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence,
    formulaireTrc: IFormulaire;
    trdMultiOccurrenceOptions: IMultiOccurrenceOptions;
    trtMultiOccurrenceOptions: IMultiOccurrenceOptions;
    gspMultiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Gs0016Controller(
    Menu: IMenuClass,
    Formulaire: IFormulaireClass,
    MenuItemAction: IMenuItemActionClass,
    FormulaireItem: IFormulaireItemClass,
    $scope: IScope,
    notificationHandler: INotificationHandler,
) {
    const vm: IPageGs0016 = this;

    vm.$onInit = $onInit;

    function $onInit() {
        vm.monoOccurrenceOptions = {
            actionsMore: new Menu([
                new MenuItemAction(
                    'LBL_BTN_COPIER',
                    'BOUCOP',
                    () => ({}),
                    {
                        icon: 'content_copy',
                        formulaireConfirmationAction: {
                            lblTitre: 'LBL_BTN_COPIER',
                            lblConfirm: 'G_LBL_BTN_VALIDER',
                            largeurFormulaire: 30,
                            formulaire: new Formulaire([
                                    new FormulaireItem('t_trlcleint')
                                ], {largeurDefaut: 100}
                            )
                        }
                    }
                )
            ])
        };

        vm.formulaireTrc = new Formulaire('LBL_BLC_TRC', [
            new FormulaireItem('trlcleint'),
            new FormulaireItem('frmdsc'),
            new FormulaireItem('trcflgpub'),
            new FormulaireItem('trcflgint', {default: 1}),
            new FormulaireItem('fiacleint'),
            new FormulaireItem('trcfintrt'),
            new FormulaireItem('vaeresreq'),
            new FormulaireItem('trcparimp'),
            new FormulaireItem('trcflgenvid', {largeur: 20}),
            new FormulaireItem('trcflgvarprt', {largeur: 20}),
            new FormulaireItem('trcflgfiximp', {largeur: 20}),
            new FormulaireItem('impcleint', {largeur: 25}),
            new FormulaireItem('trcnbrcop', {largeur: 15})
        ], {largeurDefaut: 25});

        vm.trtMultiOccurrenceOptions = {
            colonnesVisibles: [
                {nom: 'trtnumpla', largeur: 100},
                {nom: 'trtnompla', largeur: 180}
            ],
            formulaire: new Formulaire([
                new FormulaireItem('trtnumpla'),
                new FormulaireItem('trtnompla', {enableCount: true})
            ], {largeurDefaut: 25})
        };

        vm.trdMultiOccurrenceOptions = {
            fonctions: {
                editionRapide: true,
                boutonEditionRapide: false,
            },
            editionRapideActive: true,
            validationEditionRapide: () => {
                const defaultRows = vm.trdMultiOccurrence?.dataList
                    ?.filter((i:any) => !i.$deleted)
                    ?.map((i: any) => i.trdflgdef);

                const hasOneRow = vm.trdMultiOccurrence?.dataList.length === 1;
                const hasOneDefault = defaultRows.includes(1);
                const hasMoreThanOneDefault = defaultRows.filter((i:any)=> i === 1).length > 1;

                if (!hasOneDefault && !hasOneRow) {
                    notificationHandler.erreur({
                        lblTitre: 'G_LBL_ERREUR',
                        lblMessage: vm.$resolve.sourceDetailsResolver.libelles.LBL_DEFAULT_UNIQUE // 'Vous devez définir une destination par défaut.' 
                    });
                    return false;
                }

                if (hasMoreThanOneDefault) {
                    notificationHandler.erreur({
                        lblTitre: 'G_LBL_ERREUR',
                        lblMessage: vm.$resolve.sourceDetailsResolver.libelles.LBL_DEFAULT_SINGLE // 'Vous devez définir une seule destination par défaut.' 
                    });
                    return false;
                }

                return true;
            },
            colonnesVisibles: [
                {nom: 'vaedsttyp_dsc', largeur: 90},
                {nom: 'vaedstfmt_dsc', largeur: 100},
                {nom: 'vaedstlev_dsc', largeur: 110},
                {nom: 'trddstnam', largeur: 350},
                {nom: 'trddstto', largeur: 220},
                {nom: 'trddstfrm', largeur: 220},
                {nom: 'trddstsub', largeur: 220},
                {nom: 'vaedstbod_dsc', largeur: 130},
                {nom: 'trddstbod', largeur: 220}
            ],
            colonnesFixesDroite: [
                {nom: 'trdflgdef', largeur: 75},
                {nom: 'trdflgimp', largeur: 75},
                {nom: 'trdflggrp', largeur: 75}
            ],
            colonnesEditionRapide: [
                { nom: 'vaedsttyp', largeur: 130 },
                { nom: 'vaedstfmt', largeur: 100 },
                { nom: 'vaedstlev', largeur: 150 },
                { nom: 'trddstnam', largeur: 350 },
                { nom: 'trddstto', largeur: 220 },
                { nom: 'trddstfrm', largeur: 220 },
                { nom: 'trddstsub', largeur: 220 },
                { nom: 'vaedstbod', largeur: 130 },
                { nom: 'trddstbod', largeur: 220 },
                { nom: 'trdflgdef', largeur: 20 },
                { nom: 'trdflgimp', largeur: 20 },
                { nom: 'trdflggrp', largeur: 20 },
                { nom: 'trdflgsec', largeur: 20, hidden: true },
                { nom: 'trdflgpij', largeur: 20, hidden: true },
            ],
            formulaire: new Formulaire([
                new FormulaireItem('vaedsttyp'),
                new FormulaireItem('vaedstfmt'),
                new FormulaireItem('vaedstlev'),
                new FormulaireItem('trddstnam'),
                new FormulaireItem('trddstto'),
                new FormulaireItem('trddstfrm'),
                new FormulaireItem('trddstsub'),
                new FormulaireItem('vaedstbod'),
                new FormulaireItem('trddstbod'),
                new FormulaireItem('trdflgdef', {largeur: 20}),
                new FormulaireItem('trdflgimp', {largeur: 20}),
                new FormulaireItem('trdflggrp', {largeur: 20}),
                new FormulaireItem('trdflgsec', {largeur: 20, hidden: true}),
                new FormulaireItem('trdflgpij', {largeur: 20, hidden: true})
            ], {largeurDefaut: 33})
        };
    }
}
